import { CompanyProfile } from 'models';

import { useCompanyEvent } from 'components/company-profile/hooks/use-company-event';
import { useLocalEvent } from 'hooks/use-local-event';

// The event a scan belongs to: the one the visitor is at, otherwise the exhibitor's current event. Saving a scan and
// finding it again must agree on this, or a visitor's own scans look missing.
const useScanEvent = (company: Pick<CompanyProfile, 'id'>) => {
    const { event: companyEvent, isLoading: companyEventLoading } = useCompanyEvent(company);
    const { localEvent, isLoading: localEventLoading } = useLocalEvent();

    return { event: localEvent ?? companyEvent, isLoading: companyEventLoading || localEventLoading };
};

export { useScanEvent };
